import React from 'react';
import { MobileStepper, Paper, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
  {
    label: 'Check & get loan on you farm',
    imgPath: '/images/clipboard-with-pen.svg',
  },
  {
    label: 'Check & get loan on you farm abc',
    imgPath: '/images/money.svg',
  },
  {
    label: 'Check & get loan on you farm xyz',
    imgPath: '/images/clipboard-with-pen.svg',
  },
  {
    label: 'Check & get loan on you farm ghi',
    imgPath: '/images/money.svg',
  },
];

function SwipeableTextMobileStepper() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  /* function handleNext() {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  }

  function handleBack() {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  } */

  function handleStepChange(step) {
    setActiveStep(step);
  }

  return (
    <div className="root carouselHead">
      {/* <Typography variant="h6" id="modal-title">
        Benefits for Joining Uss!
      </Typography> */}
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {tutorialSteps.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <img className="img" src={step.imgPath} alt={step.label} />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <Paper square elevation={0} className="header carouseLabel">
        <Typography>{tutorialSteps[activeStep].label}</Typography>
      </Paper>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep}
      />
    </div>
  );
}

export default SwipeableTextMobileStepper;
